import axios, { AxiosRequestConfig } from 'axios'

interface CB {
    requestSuccess?: any,
    requestError?: any,
    responseSuccess?: any,
    responseError?: any
}

const BASE_URL = '/'

const defaultConfig = {
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'X-Requested-With': 'XMLHttpRequest'
  },
  timeout: 1000 * 50
}

export const requestSuccess = (config: any) => {
  return config
}

export const requestError = (err: Error) => {
  return Promise.reject(err)
}

export const responseSuccess = (res: any) => {
  const data = res.data
  const code = data.code + ''
  // TODO
  if (code === '0') {
    return data.data
  } else {
    return Promise.reject(data)
  }
}

export const responseError = (err: Error) => {
  return Promise.reject(err)
}

export const AxiosFactory = (config: AxiosRequestConfig, callback?: CB) => {
  config = Object.assign({}, defaultConfig, config)
  const instance = axios.create(config)
  instance.interceptors.request.use((callback && callback.requestSuccess) || requestSuccess, requestError)
  instance.interceptors.response.use((callback && callback.responseSuccess) || responseSuccess, responseError)
  return instance
}
